import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ObjectSchedulerComponent } from './object-scheduler.component';
import { ObjectSchedulerOperationModeComponent } from './object-scheduler-operation-mode/object-scheduler-operation-mode.component';
import { ObjectSchedulerHolidayComponent } from './object-scheduler-holiday/object-scheduler-holiday.component';
import { CalendarSchedulerHolidayComponent } from './calendar-scheduler-holiday/calendar-scheduler-holiday.component';
import { DialogModule } from 'primeng/dialog';
import { OwlDateTimeIntl, OwlDateTimeModule, OwlNativeDateTimeModule, DateTimeAdapter,  NativeDateTimeAdapter, OWL_DATE_TIME_FORMATS } from '@danielmoncada/angular-datetime-picker'; // Исправленный импорт
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ObjectHolidayComponent } from './object-holiday/object-holiday.component';
import { CalendarHolidayComponent } from './calendar-holiday/calendar-holiday.component';
import { ParamonPanelEditComponent } from './paramon-panel-edit/paramon-panel-edit.component';
import { IconKitComponent } from './paramon-panel-edit/components/icon-kit/icon-kit.component';
import { PlaningAreaBlockComponent } from './paramon-panel-edit/blocks/planing-area-block/planing-area-block.component';
import { ButtonFilterComponent } from './paramon-panel-edit/components/button-filter/button-filter.component';
import { RangeSliderComponent } from './paramon-panel-edit/components/range-slider/range-slider.component';
import { ScheduleTemplatePanelEditComponent } from './schedule-template-panel-edit/schedule-template-panel-edit.component';
import { CalendarTemplatePanelEditComponent } from './calendar-template-panel-edit/calendar-template-panel-edit.component';
import { ScheduleTemplatePlaningareaInformerComponent } from './schedule-template-planingarea-informer/schedule-template-planingarea-informer.component';
import { RuleonPanelEditComponent } from './ruleon-panel-edit/ruleon-panel-edit.component';
import { OrderByPipe } from '../shared/pipes/order-by.pipe';


import { TimeFormatDirective } from './time-format.directive';
import { RangeLocaltimeSliderComponent } from './paramon-panel-edit/components/range-localtime-slider/range-localtime-slider.component';
import { SnackBarService } from './snackbar-service';
import { ArrayFilterPipe } from './array-filter.pipe';
import { SharedModule } from '../shared/shared.module';
import { PlaningDateBlockComponent } from './paramon-panel-edit/blocks/planing-date-block/planing-date-block.component';

import { InsparkScheduleTamplateModule } from '../../../projects/common/modules/schedule-tamplate/schedule-tamplate.module';
import { InsparkTabPanelModule } from '../../../projects/common/modules/inspark-tab-panel/inspark-tab-panel.module';

import { RadioButtonModule } from 'primeng/radiobutton';
import {ScheduleTemplateApiService} from '../../../projects/api/src/scheduletemplate/scheduletemplate-api.service';
import {TimerangePanelComponent} from './timerange-panel/timerange-panel.component';
import {TimerangeApiService} from '../../../projects/api/src/timerange/timerange-api.service';
import {
  ComposeTimerangePanelModalComponent
} from './timerange-panel/compose-timerange-panel-modal/compose-timerange-panel-modal.component';
import {PageLinksModule} from '../page/shared/page-links/page-links.module';
import {
  PageStandardFormsModule
} from '../../../projects/common/modules/inspark-page-standard-forms/page-standard-forms.module';
import {PipesModule} from '../shared/pipes/pipes.module';
import {FilterByPipe} from '../../../projects/common/standalone/pipes/filter-by.pipe';

const SCHEDULER_FORMATS = {
  fullPickerInput: {year: 'numeric', month: 'numeric', day: 'numeric'},
  datePickerInput: {year: 'numeric', month: 'numeric', day: 'numeric'},
  timePickerInput: {hour: 'numeric', minute: 'numeric'},
  monthYearLabel: {year: 'numeric', month: 'short'},
  dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
  monthYearA11yLabel: {year: 'numeric', month: 'long'},
};

export class BtnLabelIntl extends OwlDateTimeIntl {
  cancelBtnLabel = this.translate.instant('Cancel');
  setBtnLabel = this.translate.instant('Set');

  constructor(private translate: TranslateService) {
    super();
    this.translate.onLangChange.subscribe(() => {
      this.translateButtons();
    });
  }
  private translateButtons() {
    this.cancelBtnLabel = this.translate.instant('Cancel');
    this.setBtnLabel = this.translate.instant('Set');
  }
}

@NgModule({
  imports: [
    CommonModule,
    DialogModule,
    OwlNativeDateTimeModule,
    OwlDateTimeModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    PipesModule,
    SharedModule,
    PageStandardFormsModule,
    InsparkScheduleTamplateModule,
    InsparkTabPanelModule,
    RadioButtonModule,
    TimerangePanelComponent,
    ComposeTimerangePanelModalComponent,
    PageLinksModule,
    FilterByPipe
  ],
  exports: [
    ObjectSchedulerComponent,
    ArrayFilterPipe,
    ScheduleTemplatePlaningareaInformerComponent,
    IconKitComponent,
    ScheduleTemplatePanelEditComponent,
    CalendarHolidayComponent,
    ScheduleTemplatePanelEditComponent,
    ParamonPanelEditComponent,
    RuleonPanelEditComponent,
    ObjectHolidayComponent,
    OrderByPipe,
    PipesModule,
    TimeFormatDirective
  ],
  declarations: [
    ObjectSchedulerComponent,
    ObjectSchedulerOperationModeComponent,
    ObjectSchedulerHolidayComponent,
    CalendarSchedulerHolidayComponent,
    ObjectHolidayComponent,
    CalendarHolidayComponent,
    ArrayFilterPipe,
    ParamonPanelEditComponent,
    RuleonPanelEditComponent,
    IconKitComponent,
    PlaningAreaBlockComponent,
    ButtonFilterComponent,
    RangeSliderComponent,
    ScheduleTemplatePanelEditComponent,
    CalendarTemplatePanelEditComponent,
    ScheduleTemplatePlaningareaInformerComponent,
    RuleonPanelEditComponent,
    OrderByPipe,
    TimeFormatDirective,
    RangeLocaltimeSliderComponent,
    ArrayFilterPipe,
    PlaningDateBlockComponent
  ],
  providers: [
    { provide: OWL_DATE_TIME_FORMATS, useValue: SCHEDULER_FORMATS },
    { provide: OwlDateTimeIntl, useClass: BtnLabelIntl, deps: [TranslateService] },
    { provide: DateTimeAdapter, useClass: NativeDateTimeAdapter }, // Используем NativeDateTimeAdapter
    SnackBarService,
    ScheduleTemplateApiService,
    TimerangeApiService
  ]
})
export class ObjectSchedulerModule { }
